// src/components/modal/FollowersUsersModal.js

import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { useCustomTheme } from '../../contexts/ThemeContext';
import {
    SuspendUserProfileProps,
    User,
    UserProfile,
} from '../../workers/ApiWorker';
import CustomModal from '../universal/modals/CustomModal';
import ErrorAlert from '../universal/alerts/ErrorAlert';
import TextInput from '../universal/inputs/TextInput';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useApi } from '../../contexts/ApiContext';
import { createWorkerFactory, useWorker } from '@shopify/react-web-worker';
import Box from '@mui/material/Box';
import { SUSPEND_USERS_FAILED } from '../../helpers/Messages';
import CircularProgress from '@mui/material/CircularProgress';
import { wait } from '@testing-library/user-event/dist/utils';
import UserList from '../user/UserList';

const createApiWorker = createWorkerFactory(
    () => import('../../workers/ApiWorker')
);

interface FollowersUsersModalProps {
    isMobile: boolean;
    isModalOpen: boolean;
    closeModal: (resetForm?: () => void) => void;
    setError: (error: string | undefined) => void; // Updated to match the state setter type
    setFollowers: (followers: number) => void;
    setFollowing: (following: number) => void;
    followers: number;
    following: number;
    error?: string;
}

const FollowersUsersModal: React.FC<FollowersUsersModalProps> = ({
    isMobile,
    isModalOpen,
    setError,
    error,
    //   selectedUsers,
    closeModal,
    setFollowers,
    setFollowing,
    followers,
    following,
}) => {
    const apiWorker = useWorker(createApiWorker);
    const { theme } = useCustomTheme();
    const { token } = useApi();

    const [userProfiles, setUserProfiles] = useState<UserProfile[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (isModalOpen) {
            setIsLoading(true);
            const getFollowers = async () => {
                if (token) {
                    const response = await apiWorker.getFollowers(token);

                    setUserProfiles(response.data);
                    await wait(1000);
                }
            };

            getFollowers()
                .then(() => {
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log('Error fetching followers:', error);
                });
        } else {
            setUserProfiles([]);
        }
    }, [token, isModalOpen]);

    return (
        <CustomModal
            isOpen={isModalOpen}
            cancelLabel={'Close'}
            onClose={() => closeModal()}
            //    onConfirm={handleSubmit}
            //     isSubmitting={isSubmitting}
            //    isValid={isValid}
            isMobile={isMobile}
        >
            {/* Modal content passed directly as children */}
            <Typography variant="h3" color={theme.palette.text.secondary}>
                FOLLOWERS
            </Typography>
            <Typography
                variant="body2"
                color={theme.palette.warning.main}
                sx={{ marginBottom: 3 }}
            >
                Users who are following you.
            </Typography>
            <Box sx={{ marginBottom: 1 }}>
                {isLoading ? (
                    <CircularProgress />
                ) : userProfiles.length === 0 ? (
                    <Typography>You have no followers.</Typography>
                ) : (
                    <UserList
                        userProfiles={userProfiles}
                        closeModal={closeModal}
                        setFollowers={setFollowers}
                        setFollowing={setFollowing}
                        followers={followers}
                        following={following}
                        isMobile={isMobile}
                    />
                )}
            </Box>
        </CustomModal>
    );
};

export default FollowersUsersModal;
